// this is done to resolve ColorThief not error in ui-cropper.js
// this is due to ui-cropper not compatible with webpack
require('imports-loader?define=>false,exports=>false!nm-ui-cropper/compile/unminified/ui-cropper.js');
import 'nm-ui-cropper/compile/unminified/ui-cropper';
import 'nm-ui-cropper/compile/unminified/ui-cropper.css';
import { ImageCropService } from './image-crop.service';

export const imageCrop = angular
    .module('imageCrop', [
        'uiCropper'
    ])
    .service('ImageCropService', ImageCropService)
    .name;


// WEBPACK FOOTER //
// ./src/app/common/libs/image-crop/image-crop.module.js